<template>
  <div class="Div">
    <div class="backimg">

      <img
        class="img"
        :src="detail.info.details_background_img"
        alt=""
      >
      <div class="Title">
        {{detail.info.overview_title_cn}}
        <p>{{detail.info.overview_title_en}}</p>
      </div>
    </div>
    <section class="section" v-html="detail.info.content_cn">
      <!-- <div class="div">
        <div class="d_t">
          &nbsp;&nbsp;&nbsp;{{detail.list[0].profile_title_cn}}
        </div>
        <div class="d_c">
          &nbsp;&nbsp;&nbsp;&nbsp;{{detail.list[0].profile_describe_cn}}
        </div>
      </div>
      <div class="div">
        <div class="d_t">
          &nbsp;&nbsp;&nbsp;{{detail.list[1].profile_title_cn}}
        </div>
        <div class="d_c">
          &nbsp;&nbsp;&nbsp;&nbsp;{{detail.list[1].profile_describe_cn}}
        </div>
      </div> -->
    </section>
    <!-- <section class="section2">
      <div class="content">
        <div
          v-for="(item,i) of detail.list.slice(2)"
          :key="i"
        >
          <div
            class="div"
            v-if="i%2==0"
            key="idv"
          >
            <img
              class="img"
              :src="item.profile_img"
              alt=""
              srcset=""
            >
            <div class="pioneer ">
              <div class="pionC">

                <div class="title">
                  {{item.profile_title_cn}}
                </div>
                <div class="summary">
                  {{item.profile_describe_cn}}
                </div>
              </div>
            </div>
          </div>
          <div
            class="div"
            v-else-if="i%2==1"
            key="idv"
          >
            <div class="pioneer pioneer1">
              <div class="pionC">

                <div class="title ellipsis">
                  成实外教育党支部多形式开展主题教育活动
                </div>
                <div
                  class="summary "
                >
               
                  {{item.profile_describe_cn}}
                </div>
              </div>
            </div>
            <img
              class="img"
              :src="item.profile_img"
              alt=""
              srcset=""
            >
          </div>

        </div>
      </div>
    </section> -->
  </div>
</template>
<script>
import { overviewDetails } from "../../api/Overview";
export default {
  name: "OverviewTwo",
  data() {
    return {
     detail: { info:{}, banner: {} }
    };
  },
  created() {
    overviewDetails({overview_id:6}).then(res => {
      // console.log(res.data);
      this.detail = res.data;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  // padding: 0.1px 0;
  //   background: #f5f5f5;
  .backimg {
    position: relative;
    width: 100%;
    height: px2Rem(400px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: absolute;
  width: 100%;
  top: px2Rem(129px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  z-index: 1;
  text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  p {
    margin-top: px2Rem(20px);
    font-size: px2Rem(40px);
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  }
}
.section {
  // width: px2Rem(1300px);
  margin: px2Rem(40px) auto px2Rem(60px);
  .div {
    margin-bottom: px2Rem(60px);
    font-size: px2Rem(40px);
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    .d_c {
      font-size: px2Rem(30px);
      line-height: px2Rem(40px);
    }
  }
}
.section2 {
  padding-bottom: px2Rem(115px);
  // background:#f5f5f5;
  .content {
    width: px2Rem(1300px);
    padding-bottom: px2Rem(40px);
    margin: px2Rem(60px) auto 0;
    font-size: 0;
    .div {
      min-height: px2Rem(420px);
      margin-bottom: px2Rem(20px);
      font-size: 0;
    }
    .img {
      display: inline-block;
      width: px2Rem(640px);
      height: px2Rem(420px);
      vertical-align: top;
    }
    .pioneer {
      position: relative;
      display: inline-block;
      width: px2Rem(625px);
      height: 100%;
      margin: 0 0 0 px2Rem(30px);
      background: rgba(255, 255, 255, 1);
      .title {
        margin: px2Rem(0px) 0 px2Rem(30px);
        font-size: px2Rem(40px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .summary {
        height: px2Rem(160px);
        line-height: px2Rem(40px);
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #606060;
      }
      .pionC {
        // position: absolute;
        width: 100%;
        // top: 50%;
        // transform: translate(0, -50%);
      }
    }
    .pioneer1 {
      margin: 0 px2Rem(35px) 0 0;
    }
  }
}
.off {
  width: 100%;
  height: px2Rem(400px);
}
</style>


// WEBPACK FOOTER //
// src/views/OverviewAndWelcome/OverviewDetailTwo.vue